import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Field, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import TrialCardItem from '../CR/TrialCardItem';
import useSavedTrialsResultList from '../../lib/hooks/coveo/useSavedTrialsResultList';
import { useEffect, useState } from 'react';
import savedTrialHeadlessEnginee from '../../lib/utils/coveo/savedTrialHeadlessEngine';
import ButtonDiscreet from '../shared/Button/ButtonDiscreet';
import { useRouter } from 'next/router';
import UiHeading from '../shared/Heading';
import { ITagProps } from '../CR/Search.type';
import UiContainer from '../shared/Container/Container';
import Carousel from '../shared/CarouselV2/Carousel';
import UiSpacer from '../shared/Spacer/Spacer';

const fallbackField = {
  value: 'fallbackValue',
};

const fallbackValue = {
  value: 'View all saved trials',
};

const fallbackViewAllField = {
  href: '/manage-my-profile/Saved-Trials',
};

const TrialItemsManageProfile = (props: any) => {
  const theme = useTheme();
  const router = useRouter();
  const { sitecoreContext } = useSitecoreContext();
  const isMyProfilePage = sitecoreContext?.route?.fields?.isMyProfilePage;
  const [trialsList, setTrialsList] = useState<any>([]);
  const title = props?.fields?.title || fallbackField;
  const viewAllButton = props?.fields?.viewAllButton || fallbackViewAllField;
  const ViewTextButton: Field<string> = viewAllButton?.text || fallbackValue;
  const {
    notYetEnrolling,
    goodMatch,
    virtual,
    enrolling,
    fontWeight,
    fontSize,
    tagFontWeight,
    favoriteButtonColor,
    lineCount,
    valueFontColor,
  } = props?.fields;

  const trialCardProps: ITagProps = {
    notYetEnrolling,
    goodMatch,
    virtual,
    enrolling,
    fontWeight,
    fontSize,
    tagFontWeight,
    favoriteButtonColor,
    lineCount,
    valueFontColor,
  };

  const { state } = useSavedTrialsResultList(
    savedTrialHeadlessEnginee,
    props?.fields?.noOfRecordsPerPage?.value || 12
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTrialsList(state?.results);
    }
  }, [state]);

  const [fieldsData] = useState(() => {
    const fieldsData: any = [];
    props?.fields?.searchTrialFields?.forEach((item: any) => {
      if (item?.fields?.key?.value && item?.fields?.icon?.value && item?.fields?.label?.value) {
        fieldsData.push({
          label: item?.fields?.label,
          icon: item?.fields?.icon,
          key: item?.fields?.key,
        });
      }
    });
    return fieldsData;
  });

  const handleAllSavedTrialCard = () => {
    const path = viewAllButton?.value?.href;
    if (path) {
      router.push(path);
    }
  };

  const trialCardItemDataArr: any = [];

  if (Array.isArray(trialsList)) {
    trialsList?.forEach((trial: any) => {
      trialCardItemDataArr.push({
        fieldsData,
        coveoTrialObj: trial,
      });
    });
  }

  const modalProps = {
    title: props?.fields?.modalTitle,
    description: props?.fields?.modalDescription,
    customButtons: props?.fields?.modalCTAButtons,
  };

  return (
    <>
      {Array.isArray(trialCardItemDataArr) && trialCardItemDataArr.length > 0 ? (
        <Box
          sx={{
            backgroundColor: theme.palette.white.main,
            padding: '48px 0',
            ...(isMyProfilePage && { backgroundColor: theme.palette.backgroundColorType3.main }),
          }}
          id="article-carousel"
        >
          <UiContainer>
            <UiHeading size="h2" align="center">
              {title}
            </UiHeading>
            <UiSpacer size="sm" />
            <Carousel columnSize={3} spacing={1.5} showScrollbar>
              {trialCardItemDataArr.map((item: any, index: number) => (
                <Carousel.Item key={index} columnSize={3}>
                  <TrialCardItem
                    data={item}
                    key={index}
                    modalProps={modalProps}
                    state={state}
                    tagProps={trialCardProps}
                    style={{
                      minWidth: '362px',
                      height: '100%',
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
            <>
              {Array.isArray(trialCardItemDataArr) && trialCardItemDataArr.length > 3 && (
                <Box display={'flex'} justifyContent={'center'}>
                  <ButtonDiscreet onClick={handleAllSavedTrialCard}>
                    <Text field={ViewTextButton} />
                  </ButtonDiscreet>
                </Box>
              )}
            </>
          </UiContainer>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
export default TrialItemsManageProfile;
